import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=0276b1ac&"
import script from "./CollectionDetail.vue?vue&type=script&lang=js&"
export * from "./CollectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=0276b1ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports